import React, { useState } from 'react';

import cn from 'classnames';

import uploadCsvLogo from 'assets/images/properties/upload-csv.svg';
import { ReturnComponentType } from 'common';
import { useDragAndDrop } from 'hooks';
import { Button } from 'ui-kit';
import './CsvUploader.scss';

type CsvUploaderType = {
  files: File[];
  setFiles: (files: File[]) => void;
  className?: string;
};

export const CsvUploader = ({
  files,
  setFiles,
  className,
}: CsvUploaderType): ReturnComponentType => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const { onDragOver, onDrop, handleFiles, fileInput } = useDragAndDrop({
    files,
    setFiles,
    setNotification: (message: string) => setErrorMessage(message),
  });

  return (
    <div onDragOver={onDragOver} onDrop={onDrop} className={cn('CsvUploader', className)}>
      <img src={uploadCsvLogo} alt="upload-csv-logo" />
      {files.length === 0 ? (
        <>
          <h4>Upload CSV file</h4>
          <div>Click in the button or drag and drop your file here</div>
        </>
      ) : (
        <>
          <h4>{files[0]?.name}</h4>
          <div>
            To change uploaded file click in the button or drag and drop your file here
          </div>
        </>
      )}
      {errorMessage && <div className="CsvUploader_Error">{errorMessage}</div>}
      <Button onClick={() => fileInput?.current?.click()}>Upload a File</Button>

      <input
        type="file"
        accept="text/csv"
        ref={fileInput}
        multiple={false}
        hidden
        onChange={e => {
          if (e?.target?.files?.length && e.target.files.length > 0) {
            handleFiles(e.target.files);
          }
        }}
      />
    </div>
  );
};
